import { render, staticRenderFns } from "./main2d.vue?vue&type=template&id=50cbde9d&"
import script from "./main2d.vue?vue&type=script&lang=ts&"
export * from "./main2d.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports